import { Flag } from '@weave/schema-gen-ts/dist/schemas/feature-flags/feature_flags_types.pb';
import { useQuery } from 'react-query';
import { theme } from '@frontend/theme';
import { Modal, ModalControlModalProps, Text } from '@frontend/design-system';
import { getLocationsWithFlag } from '../queries';

type Props = {
  modalProps: ModalControlModalProps;
  flag?: Flag;
};

export const LocationsEnabledModal = ({ modalProps, flag }: Props) => {
  const { data: locationsWithFlag } = useQuery({
    queryKey: ['locations-with-flag', flag?.name],
    queryFn: () => getLocationsWithFlag({ flagName: flag?.name ?? '', value: true }),
    enabled: !!flag?.name,
  });

  const { data: locationsWithoutFlag } = useQuery({
    queryKey: ['locations-without-flag', flag?.name],
    queryFn: () => getLocationsWithFlag({ flagName: flag?.name ?? '', value: false }),
    enabled: !!flag?.name,
  });

  return (
    <Modal {...modalProps} minWidth={600}>
      <Modal.Header onClose={modalProps.onClose}>{'Locations Enabled '}</Modal.Header>
      <Modal.Body css={{ paddingTop: theme.spacing(2) }}>
        <Text>Count on: {locationsWithFlag?.locationIds?.length ?? 0}</Text>
        <Text>Count off: {locationsWithoutFlag?.locationIds?.length ?? 0}</Text>
      </Modal.Body>
      <Modal.Footer
        secondary={{
          label: 'Cancel',
          onClick: modalProps.onClose,
        }}
      />
    </Modal>
  );
};
